<script setup>
// Bold gradient page-header band for public catalog + detail pages, matching
// the home's promo-card look. Colour keys off `kind` (vehicle coral / tour
// lagoon / property ink). `top` slot = back link; default slot = lede / price
// / CTAs under the title.
defineProps({
  kind:    { type: String, default: 'vehicle' }, // vehicle | tour | property
  eyebrow: { type: String, default: '' },
  title:   { type: String, required: true },
})
</script>

<template>
  <section :class="['bhero', `bhero--${kind}`]">
    <svg class="bhero__sun" viewBox="0 0 120 120" aria-hidden="true">
      <g stroke="currentColor" stroke-width="6" stroke-linecap="round">
        <line x1="60" y1="6" x2="60" y2="30" /><line x1="60" y1="90" x2="60" y2="114" />
        <line x1="6" y1="60" x2="30" y2="60" /><line x1="90" y1="60" x2="114" y2="60" />
        <line x1="22" y1="22" x2="38" y2="38" /><line x1="82" y1="82" x2="98" y2="98" />
        <line x1="98" y1="22" x2="82" y2="38" /><line x1="38" y1="82" x2="22" y2="98" />
      </g>
      <circle cx="60" cy="60" r="22" fill="currentColor" />
    </svg>
    <div class="bhero__inner">
      <slot name="top" />
      <p v-if="eyebrow" class="bhero__eyebrow">{{ eyebrow }}</p>
      <h1 class="bhero__title">{{ title }}</h1>
      <slot />
    </div>
  </section>
</template>

<style scoped>
.bhero { position: relative; overflow: hidden; width: 100%; }
.bhero__sun {
  position: absolute; top: -7rem; right: -3rem; width: 26rem; height: 26rem;
  color: currentColor; opacity: 0.14; pointer-events: none;
}
.bhero__inner {
  max-width: 96rem; margin: 0 auto;
  padding: clamp(2.5rem, 6vw, 5rem) clamp(1.25rem, 4vw, 3rem) clamp(2.25rem, 5vw, 4rem);
  position: relative;
}
.bhero__eyebrow {
  font-size: 0.8rem; letter-spacing: 0.2em; text-transform: uppercase;
  font-weight: 700; margin: 0 0 0.7rem; opacity: 0.88;
}
.bhero__title {
  font-family: var(--font-display, var(--display)); font-weight: 800;
  font-size: clamp(2.25rem, 5.5vw, 3.5rem); line-height: 1.02;
  letter-spacing: -0.025em; margin: 0; max-width: 20ch;
}

/* Colourways — mirror the home promo cards. */
.bhero--vehicle {
  color: var(--accentInk);
  background: radial-gradient(120% 130% at 85% 8%, color-mix(in oklch, var(--accent) 80%, white) 0%, var(--accent) 48%, color-mix(in oklch, var(--accent) 75%, black) 100%);
}
.bhero--tour {
  color: #fff;
  background: radial-gradient(120% 130% at 85% 8%, color-mix(in oklch, var(--second) 78%, white) 0%, var(--second) 48%, color-mix(in oklch, var(--second) 72%, black) 100%);
}
.bhero--property {
  color: var(--bg);
  background: linear-gradient(155deg, color-mix(in oklch, var(--ink) 92%, var(--second)) 0%, var(--ink) 70%);
}
</style>
